import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCugRedirect = loadable(() => import(/* webpackChunkName: "content/guest/travel/stays/cug-not-verified" */ './CUGRedirect'), 'CUGNotVerified');
